// @flow
export default {
  contactUsOperation: { model: null },
}
